import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { ImportFinanceCategoriesResponse } from "@/types";

async function importFinanceCategories(
  request: FormData
): Promise<ImportFinanceCategoriesResponse> {
  const response = await httpRequest.post<ImportFinanceCategoriesResponse>(
    "/finance-categorie-entries/import",
    request,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export function useImportFinanceCategoriesMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: importFinanceCategories,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["finance-categorie-entries"] });
    },
  });
}